import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'
import {LiveCasinoService} from "../services/livecasino.service";
import {Location} from '@angular/common';

@Component({
  selector: 'app-casino-details',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
  providers: []
})
export class CasinoDetailComponent implements OnInit {
  public gameid: any;
  gameurl: any = "";

  constructor(private liveCasinoService: LiveCasinoService,private sanitizer: DomSanitizer,private route: ActivatedRoute,private _location: Location) {
  }

  ngOnInit(): void {
    this.gameid = this.route.snapshot.paramMap.get('gameid');
    this.getGameUrl(this.gameid);
    console.log(this.gameid);
  }

  getGameUrl(gameid: any) {
    //const gi = "AR";
    this.liveCasinoService.getGamesUrlByidRequests(gameid).subscribe((res: any) => {
      this.gameurl = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
    });
  }

  backClicked(){
    this._location.back();
  }
}
